import React from 'react';

import CertificateCard from '../../shared/CertificateCard';
import AccountantCard from '../shared/AccountantCard';
import ReadOnlyField from '../shared/ReadOnlyField';
import SectionCard from '../shared/SectionCard';
import {
  displayText,
  formatBoolean,
  formatPhone,
  formatSimplesNacional,
  NOT_INFORMED,
} from '../shared/formatters';
import { formatDateOnly } from '../shared/status';
import { shippingTypeOptions } from '../mockData';

// O tipo chega como { id, name }; o fallback cobre a resposta que traz só o id.
function formatShippingType(anttType) {
  if (anttType?.name) return anttType.name;
  const option = shippingTypeOptions.find((o) => o.value === anttType?.id);
  return option?.label || NOT_INFORMED;
}

function formatCity(city) {
  if (!city?.name) return NOT_INFORMED;
  return city.province?.uf ? `${city.name} - ${city.province.uf}` : city.name;
}

function formatProvince(province) {
  if (!province?.name) return displayText(province?.uf);
  return province.uf ? `${province.name} (${province.uf})` : province.name;
}

// Visão somente leitura dos dados do cadastro, a partir da aprovação (RN-001). Os valores já chegam
// resolvidos do cadastro vigente da transportadora pelo backend (RN-002) — nada é consultado aqui.
export default function ReadOnlyData({ request }) {
  const isAutonomous = request.autonomous === true;
  const documents = request.documents || [];
  const showDocuments = !isAutonomous && documents.length > 0;

  return (
    <>
      <SectionCard title="Dados do usuário para acesso">
        <ReadOnlyField md={6} label="Nome Completo" value={displayText(request.userName)} />
        <ReadOnlyField md={6} label="CPF do Usuário" value={displayText(request.userDocument)} />
        <ReadOnlyField md={6} label="E-mail do Usuário" value={displayText(request.userEmail)} />
        <ReadOnlyField md={6} label="Telefone" value={formatPhone(request.userPhone)} />
      </SectionCard>

      <SectionCard title="Dados da transportadora">
        <ReadOnlyField label="Autônomo" value={formatBoolean(request.autonomous, 'Sim', 'Não')} />
        <ReadOnlyField
          label={isAutonomous ? 'CPF' : 'CNPJ'}
          value={displayText(request.shippingDocument)}
        />
        {isAutonomous && <ReadOnlyField label="PIS" value={displayText(request.pis)} />}
        <ReadOnlyField label="Razão Social" value={displayText(request.shippingName)} />
        {!isAutonomous && (
          <ReadOnlyField
            label="Inscrição Estadual"
            value={displayText(request.shippingStateRegistration)}
          />
        )}
        <ReadOnlyField label="Telefone" value={formatPhone(request.shippingPhone)} />
        <ReadOnlyField label="E-mail" value={displayText(request.shippingEmail)} />
        <ReadOnlyField label="Tipo" value={formatShippingType(request.anttType)} />
        <ReadOnlyField
          label="Optante Simples Nacional"
          value={formatSimplesNacional(request.shippingSimplesNacional)}
        />
      </SectionCard>

      <AccountantCard
        name={request.accountantName}
        phone={request.accountantPhone}
        email={request.accountantEmail}
      />

      <SectionCard title="Endereço">
        <ReadOnlyField label="País" value={displayText(request.country?.name)} />
        <ReadOnlyField md={8} label="Logradouro" value={displayText(request.addressStreet)} />
        <ReadOnlyField md={3} label="Número" value={displayText(request.addressNumber)} />
        <ReadOnlyField md={5} label="Bairro" value={displayText(request.addressDistrict)} />
        <ReadOnlyField label="CEP" value={displayText(request.addressCep)} />
        <ReadOnlyField md={6} label="Cidade" value={formatCity(request.city)} />
        <ReadOnlyField md={3} label="Estado" value={formatProvince(request.province)} />
        <ReadOnlyField md={3} label="Complemento" value={displayText(request.addressComplement)} />
      </SectionCard>

      <SectionCard title="ANTT / RNTRC">
        <ReadOnlyField label="Número RNTRC" value={displayText(request.anttRntrcNumber)} />
        <ReadOnlyField label="Data de Emissão" value={formatDateOnly(request.anttIssueDate)} />
        <ReadOnlyField label="Data de Validade" value={formatDateOnly(request.anttExpDate)} />
        <ReadOnlyField label="Tipo" value={formatShippingType(request.anttType)} />
        <ReadOnlyField
          label="RNTRC"
          value={formatBoolean(request.anttIsOwner, 'Própria', 'De terceiros')}
        />
        {request.anttIsOwner === false && (
          <ReadOnlyField
            label="CPF / CNPJ do transportador"
            value={displayText(request.anttDocument)}
          />
        )}
      </SectionCard>

      {showDocuments && (
        <SectionCard title="CNPJs vinculados">
          {documents.map((doc, index) => (
            <ReadOnlyField
              key={doc.id ?? `doc-${index}`}
              label="CNPJ"
              value={displayText(doc.document)}
            />
          ))}
        </SectionCard>
      )}

      <CertificateCard personId={request.shippingCompanyId} />
    </>
  );
}
